// 站内文案大小写统一：
// 1) 每段/每句首字母大写，其余字母小写（Title Case 会被还原成句首大写）；
// 2) 全大写词（车型名、英文缩写如 LED / ABS）原样保留；
// 3) 传入的车型名 / 型号 / 品牌名强制转成大写并原样保留；
// 4) 多行文本的换行、标点、重音字母都不改动。
const WORD_PATTERN = /[A-Za-zÀ-ÖØ-öø-ÿ]+(?:['’\-][A-Za-zÀ-ÖØ-öø-ÿ]+)*/g
const SENTENCE_END_PATTERN = /[.!?…:]\s*$/
const UPPERCASE_PATTERN = /[A-ZÀ-Þ]/
const CAPITALISED_PATTERN = /^[A-ZÀ-Þ]/
// 占位符用「全大写字母」拼成，这样解析时会当作缩写词原样保留，也不会被误当成句首
const SLOT_PATTERN = /XQ([A-Z]{1,3})QX/g

function escapeRegExp (value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function isAllCaps (word) {
  // 单个字母按普通单词处理（句首 "A" 保留、句中 "A" 变 "a"），
  // 英文人称代词 "I" 原样保留
  if (word.length < 2) return word === 'I'
  return UPPERCASE_PATTERN.test(word) && word === word.toUpperCase()
}

function slotCode (index) {
  let value = index + 1
  let code = ''
  while (value > 0) {
    const remainder = (value - 1) % 26
    code = String.fromCharCode(65 + remainder) + code
    value = Math.floor((value - 1) / 26)
  }
  return code
}

export function formatCopyText (value, keepWords) {
  let text = String(value == null ? '' : value)
  if (!text.trim()) return text

  // 品牌名 + 车型名 / 型号：先挖空，最后再按大写还原
  const keeps = ['BECANE']
    .concat(Array.isArray(keepWords) ? keepWords : [keepWords])
    .map(item => String(item == null ? '' : item).trim())
    .filter((item, index, list) => item.length > 1 && list.findIndex(other => other.toLowerCase() === item.toLowerCase()) === index)
    .sort((a, b) => b.length - a.length)

  const slots = []
  keeps.forEach(token => {
    const pattern = new RegExp(escapeRegExp(token).replace(/\s+/g, '\\s+'), 'gi')
    text = text.replace(pattern, () => {
      slots.push(token.toUpperCase())
      return 'XQ' + slotCode(slots.length - 1) + 'QX'
    })
  })

  let result = ''
  let cursor = 0
  let sentenceStart = true
  let match
  WORD_PATTERN.lastIndex = 0
  while ((match = WORD_PATTERN.exec(text)) !== null) {
    const between = text.slice(cursor, match.index)
    result += between
    if (SENTENCE_END_PATTERN.test(between)) {
      sentenceStart = true
    }
    const word = match[0]
    if (isAllCaps(word)) {
      result += word
    } else if (sentenceStart) {
      result += word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    } else if (CAPITALISED_PATTERN.test(word)) {
      result += word.charAt(0).toLowerCase() + word.slice(1)
    } else {
      result += word
    }
    sentenceStart = false
    cursor = match.index + word.length
  }
  result += text.slice(cursor)
  return result.replace(SLOT_PATTERN, (full, code) => {
    let index = 0
    for (let i = 0; i < code.length; i++) {
      index = index * 26 + (code.charCodeAt(i) - 64)
    }
    return slots[index - 1] || full
  })
}

export default formatCopyText
